export default "__VITE_ASSET__CrBinkET__"